import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const ICONS = {
  success: (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
      <path d="M20 6L9 17l-5-5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  error: (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
      <path d="M18 6L6 18M6 6l12 12" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  undo: (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
      <rect x="4" y="11" width="16" height="9" rx="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4 11V7a2 2 0 012-2h12a2 2 0 012 2v4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
};

const COLORS = {
  success: { fg: '#248a3d', tint: 'rgba(52,199,89,0.14)' },
  error: { fg: '#c4162a', tint: 'rgba(255,55,95,0.14)' },
  undo: { fg: '#525252', tint: 'rgba(0,0,0,0.06)' },
};

const ToastStack = ({ toasts, onDismiss }) => {
  const { t } = useLanguage();
  if (!toasts.length) return null;
  return (
    <div
      className="fixed z-[200] flex flex-col gap-2 items-end"
      style={{ bottom: 20, right: 20, maxWidth: 360 }}
    >
      <style>{`
        @keyframes contact-toast-in { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: translateY(0); } }
      `}</style>
      {toasts.map((item) => {
        const c = COLORS[item.type] || COLORS.success;
        return (
          <div
            key={item.id}
            className="flex items-start gap-3 bg-white w-full"
            style={{
              borderRadius: 14,
              padding: '13px 14px',
              boxShadow: '0 12px 32px rgba(0,0,0,0.16)',
              border: '1px solid rgba(0,0,0,0.06)',
              animation: 'contact-toast-in .25s ease',
            }}
          >
            <div
              className="flex items-center justify-center flex-shrink-0"
              style={{ width: 22, height: 22, borderRadius: '50%', background: c.tint, color: c.fg, marginTop: 1 }}
            >
              {ICONS[item.type] || ICONS.success}
            </div>
            <p className="text-sm flex-1" style={{ color: '#1d1d1f', lineHeight: 1.4, margin: 0 }}>
              {item.message}
            </p>
            {item.type === 'undo' && (
              <button
                onClick={item.onUndo}
                className="flex-shrink-0 hover:opacity-75 transition"
                style={{
                  color: '#0071e3',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  padding: 0,
                  fontSize: 13,
                  fontWeight: 600,
                  marginTop: 1,
                  whiteSpace: 'nowrap',
                }}
              >
                {t('toastStack.undo', 'Deshacer')}
              </button>
            )}
            <button
              onClick={() => onDismiss(item.id)}
              className="flex-shrink-0 hover:opacity-70 transition"
              style={{ color: '#a1a1a6', marginTop: 2, background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
              aria-label={t('toastStack.close', 'Cerrar')}
            >
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <path d="M18 6L6 18M6 6l12 12" strokeLinecap="round" />
              </svg>
            </button>
          </div>
        );
      })}
    </div>
  );
};

export default ToastStack;
